var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('select-date-header'),_c('select-date-title',{attrs:{"activeTab":_vm.activeTab}}),_c('select-date-content',{on:{"selectDate":_vm.selectDate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }